var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgarTelecomLogoMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 58,
    viewBox: "0 0 148 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.495 13.8248C122.495 13.3411 122.777 12.8575 123.219 12.5753C123.702 12.2932 124.306 12.3335 124.748 12.6156L133.357 17.5733C133.799 17.8554 134.081 18.2988 134.081 18.8227C134.081 19.387 133.759 19.8707 133.276 20.1528C133.276 20.1528 124.708 25.1104 124.668 25.1507C124.225 25.3926 123.662 25.3926 123.219 25.1507C122.737 24.8686 122.455 24.3446 122.495 23.8207V19.7498V13.8248Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.294 21.7651C136.294 21.2815 136.575 20.7978 137.018 20.5156C137.5 20.2335 138.104 20.2738 138.546 20.556L147.155 25.5136C147.598 25.7554 147.879 26.2391 147.879 26.763C147.879 27.3273 147.558 27.811 147.075 28.0931C147.075 28.0931 138.506 33.0507 138.466 33.0507C138.023 33.2926 137.46 33.2926 137.018 33.0104C136.535 32.7283 136.253 32.2043 136.294 31.6803V21.7651Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.495 29.7456C122.495 29.2619 122.777 28.7783 123.219 28.4961C123.702 28.214 124.306 28.2543 124.748 28.5364L133.357 33.494C133.799 33.7359 134.081 34.2195 134.081 34.7435C134.081 35.3078 133.759 35.8318 133.276 36.0736C133.276 36.0736 124.708 41.0312 124.668 41.0312C124.225 41.273 123.662 41.2731 123.219 40.9909C122.737 40.7088 122.455 40.1848 122.495 39.6608V35.5899V29.7456Z",
    fill: "#00A651"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgarTelecomLogoMin);
export default __webpack_public_path__ + "static/media/algar_Telecom_logo_min.f24960949dde1c30caf2922e5bb6099f.svg";
export { ForwardRef as ReactComponent };